<template>
  <div class="detail-wrap">
    <el-form ref="editForm" :model="formData">
      <div class="d-header clearfix">
        <div class="fl">
          <i class="el-icon-info"/>
          {{ dataId ? '查看' : '新增' }}特设费用
        </div>
        <div class="fr">
          <!--          <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-refresh-right">重置-->
          <!--          </el-button>-->
          <el-button type="primary" class="button-sty" icon="el-icon-check" @click="saveData">保存</el-button>
        </div>
      </div>
      <div>

        <!-- 品牌信息 -->
        <div class="d-cont edit-mce-box">
          <div class="d-item">
            <div class="title first">
              <b>主信息</b>
            </div>
            <table class="table-detail">
              <tbody>
              <tr>
                <th>
                  <em class="f-red">*</em>
                  特设费用名称
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.name" clearable/>
                </td>
                <th>
                  <em class="f-red">*</em>
                  类型
                </th>
                <td>
                  <el-select v-model="formData.feeType">
                    <el-option label="向公司申请" :value="1"/>
                    <el-option label="向用户收取" :value="2"/>
                  </el-select>
                </td>
                <th>
                  <em class="f-red">*</em>
                  金额/  <em class="f-red">*</em>单位
                </th>
                <td style="display: flex;flex-direction: row;justify-content: space-between;">
                  <el-input style="width: 49%!important;" type="number" oninput="if(value<0||value>9999)value=0" autocomplete="off"
                            v-model="formData.price" clearable/>

                            <el-input style="width: 49%!important;" type="text" autocomplete="off" v-model="formData.unit" clearable/>
                </td>
                <th>
                  <em class="f-red">*</em>
                  启用
                </th>
                <td>
                  <el-select v-model="formData.stat">
                    <el-option label="禁用" :value="0"/>
                    <el-option label="启用" :value="1"/>
                  </el-select>
                </td>
                <!-- <th>
                  <em class="f-red">*</em>
                  计价
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.unit" clearable/>
                </td> -->
              </tr>
              <tr>
              
              </tr>
              <tr>
                <th>创建人</th>
                <td>{{ formData.createBy }}</td>
                <th>创建时间</th>
                <td>{{ formData.createTime }}</td>
              </tr>
              </tbody>
            </table>
          </div>

          <div style="display: flex;">
            <div class="d-item">
              <div class="title first" style="display: flex;flex-direction: row;
    justify-content: space-between;">
                <b>费用条件</b>
                      <div class="item-button">
                        <el-button type="primary" class="button-sty btn_zdy" @click="showItemPop=true">
                          <i class="el-icon-plus"></i>
                          产品
                        </el-button>&nbsp;
                        <el-button
                                   type="primary" class="button-sty btn_zdy" @click="handleDeleteItemList">
                          <i class="el-icon-delete"></i>
                          批量删除
                        </el-button>
                  </div>
              </div>

              <div style="display: flex; width: 100%; justify-content: space-around;" >
                <div class="current-info" >
                  <!--保修类型-->
                  <vxe-table
                    class="mytable-scrollbar"
                    :stripe="true"
                    :header-cell-style="{height: '30px',  background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                    :row-config="{height: 30,isHover: true, padding: 0, keyField: 'id', }"
                    :row-style="{ fontSize: '12px',  }"
                    show-overflow
                    height="260" :column-config="{ resizable: true }"
                    resizable
                    row-id="id"
                    :checkbox-config="{checkRowKeys: selectedGuaranteeTypeIdList, highlight: false}"
                    :data="guaranteeTypeList"
                    @checkbox-change="guaranteeTypeSelectChangeEvent"
                    @checkbox-all="guaranteeTypeSelectChangeEvent"
                  >
                    <vxe-column type="checkbox" field="id" width="40"></vxe-column>
                    <vxe-column field="type" width="120" title="保修类型"></vxe-column>
                  </vxe-table>
                </div>
                <div class="current-info" >
                  <!--品牌-->
                  <vxe-table
                    class="mytable-scrollbar"
                    :stripe="true"
                    :header-cell-style="{height: '30px',  background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                    :row-config="{height: 30,isHover: true, padding: 0,}"
                    :row-style="{ fontSize: '12px',  }"
                    show-overflow
                    height="260" :column-config="{ resizable: true }"
                    resizable
                    row-id="id"
                    :checkbox-config="{labelField: 'name', checkRowKeys: selectedBrandIdList}"
                    :data="formData.snCompanyBrandList"
                    @checkbox-change="brandSelectChangeEvent"
                    @checkbox-all="brandSelectChangeEvent"
                  >
                    <vxe-column type="checkbox" width="40"></vxe-column>
                    <vxe-column field="brandName" width="120" title="品牌"></vxe-column>
                  </vxe-table>
                </div>
                <div class="current-info" style="width:240px;">
                  <!--产品类型-->
                  <vxe-table
                    class="mytable-scrollbar"
                    :stripe="true"
                    :header-cell-style="{height: '30px',  background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                    :row-config="{height: 30,isHover: true,padding: 0,}"
                    :row-style="{ fontSize: '12px',  }"
                    show-overflow
                    height="260" :column-config="{ resizable: true }"
                    resizable
                    row-id="id"
                    :tree-config="{transform: true}"
                    :checkbox-config="{labelField: 'name', checkRowKeys: selectedItemCategoryIdList}"
                    :data="formData.itemCategoryList"
                    @checkbox-change="itemCategorySelectChangeEvent"
                    @checkbox-all="itemCategorySelectChangeEvent"
                  >
                    <vxe-column type="checkbox" width="80" :tree-node="true"></vxe-column>
                    <vxe-column field="categoryName" width="150" title="产品类型"></vxe-column>
                  </vxe-table>
                </div>
                <div class="current-info" style="width:240px;">
                  <!-- 服务类型 -->
                  <vxe-table
                    class="mytable-scrollbar"
                    :stripe="true"
                    :header-cell-style="{height: '30px',  background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                    :row-config="{height: 30,isHover: true,padding: 0,}"
                    :row-style="{ fontSize: '12px',  }"
                    show-overflow
                    height="260" :column-config="{ resizable: true }"
                    resizable
                    row-id="id"
                    :tree-config="{transform: true}"
                    :checkbox-config="{labelField: 'name', checkRowKeys: selectedServiceTypeIdList}"
                    :data="formData.serviceTypeList"
                    @checkbox-change="serviceTypeSelectChangeEvent"
                    @checkbox-all="serviceTypeSelectChangeEvent"
                  >
                    <vxe-column type="checkbox" width="80" :tree-node="true"></vxe-column>
                    <vxe-column field="serviceTypeName" width="150" title="服务类型"></vxe-column>
                  </vxe-table>
                </div>
                <div class="current-info" >
                  <vxe-table ref="filterTable" height="260"
                             class="table_item pic_item mytable-scrollbar"
                             :column-config="{ resizable: true }"
                             style="width: 100%;"
                             :stripe="true"
                             :header-cell-style="{height: '30px',  background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                             :row-config="{height: 30,isHover: true,padding: 0,}"
                             :row-style="{ fontSize: '12px',  }"
                             show-overflow
                             :data="itemList"
                             @checkbox-all="itemSelectChangeEvent"
                             @checkbox-change="itemSelectChangeEvent"
                  >
                    <vxe-column type="checkbox" width="40"/>
                    <vxe-column field="itemName" title="产品名称" width="180"/>
                    <vxe-column field="itemCode" title="产品编码" width="180"/>
                    <vxe-column title="操作" width="60">
                      <template #default="{row}">
                        <div @click="handleDeleteItem(row.id)">
                          <el-tooltip :enterable="false" effect="dark" content="删除" placement="top"
                                      popper-class="tooltip-skin">
                            <i class="el-icon-delete" style="font-size: 18px; color: #00c4b3"></i>
                          </el-tooltip>
                        </div>
                      </template>
                    </vxe-column>
                  </vxe-table>

                </div>
              </div>

            </div>

          </div>
        </div>
      </div>
    </el-form>
    <item-pop v-if="showItemPop"
              :visiable.sync="showItemPop"

              @confirm="commitSelectedRow"
              :excludeList="itemList"
    />
  </div>
</template>
<script>

import api from "@/api/projectApi";
import itemPop from "@/components/pop/checkboxItemPop.vue"

export default {
  name: 'edit',
  props: {
    _dataId: [String, Number]
  },
  components: {
    itemPop
  },
  data() {
    return {
      showGuaranteeTypeList: true,
      showItemPop: false,
      showEdit: false,
      activeName: 'first',
      isEdit: false,
      dataId: '',
      formData: {
        id: '',  // 主键id,自动新增
        createBy: '',  // 创建人
        createTime: '',  // 创建时间
        feeType: 1,  // 类型:1向公司申请;2向用户收取
        name: '',  // 特设费用名称
        price: 0,  // 金额
        unit: '',  // 计价单位
        stat: 0,  // 启用:0禁用；1启用

        itemCategoryList: [],
        serviceTypeList: [],
        snCompanyBrandList: [],
        sfSpecialFeeSubjectConditionDTO: {
          brandId: null,
          serverTypeId: null,
          smallCategoryId: null,
          itemId: null,
          guaranteeType: null
        }
      },
      selectedBrandIdList: [],
      selectedItemCategoryIdList: [],
      selectedServiceTypeIdList: [],
      selectedGuaranteeTypeIdList: [],

      itemList: [],
      selectedItemList: [],

      guaranteeTypeList: []
    }
  },
  created() {
    if (this._dataId && !isNaN(this._dataId)) this.dataId = this._dataId
  },
  mounted() {
    this.getData();
  },

  methods: {

    // 产品批量删除
    handleDeleteItemList() {
      if (this.selectedItemList.length === 0) {
        this.$message.warning('请先勾选产品')
      } else {
        this.$baseConfirm('您确定要删除吗？').then(() => {
          this.selectedItemList.forEach(item0 => {
            this.itemList = this.itemList.filter(item => item.id !== item0)
          })
        })
      }
    },

    // 产品删除
    handleDeleteItem(id) {
      this.$baseConfirm('您确定要删除吗？').then(() => {
        this.itemList = this.itemList.filter(item => item.id !== id)
      })
    },

    // 产品复选框
    itemSelectChangeEvent({records}) {
      this.selectedItemList = records.map(item => item.id)
      console.log('产品选中', this.selectedItemList)
    },

    // 弹框选中
   commitSelectedRow(data) {
      console.log(data, '弹框选中')
      let temp = this.itemList
      if (temp.length === 0) {
        this.itemList = data
      } else {
        data.forEach(item => {
          temp.push(item)
        })
      }
    },

    // 保修类型复选框
    guaranteeTypeSelectChangeEvent({records}) {
      this.selectedGuaranteeTypeIdList = records.map(item => item.id)
      console.log('保修类型选中', this.selectedGuaranteeTypeIdList)
    },

    // 品牌复选框
    brandSelectChangeEvent({records}) {
      this.selectedBrandIdList = records.map(item => item.id)
      console.log('品牌选中', this.selectedBrandIdList)
    },

    // 服务品类复选框
    itemCategorySelectChangeEvent({records}) {
      // 拿到所有id
      let temp = records.map(item => item.id)

      // 获取有子类的父id
      let parentTemp = new Set()
      records.forEach(item => {
        if (item.parentId != 0) {
          parentTemp.add(item.parentId)
        }
      })

      // 去除有子类的父id
      let temp1 = []
      temp.forEach(item => {
        if (!parentTemp.has(item)) {
          temp1.push(item)
        }
      })
      this.selectedItemCategoryIdList = temp1
      console.log('选中的服务品类id', temp1)
    },

    // 服务类型复选框
    serviceTypeSelectChangeEvent({records}) {
      // 拿到所有id
      let temp = records.map(item => item.id)

      // 获取有子类的父id
      let parentTemp = new Set()
      records.forEach(item => {
        if (item.parentId != 0) {
          parentTemp.add(item.parentId)
        }
      })

      // 去除有子类的父id
      let temp1 = []
      temp.forEach(item => {
        if (!parentTemp.has(item)) {
          temp1.push(item)
        }
      })
      this.selectedServiceTypeIdList = temp1
      console.log('选中的服务类型id', temp1)
    },


    // 新增数据时初始化
    init() {
      this.$http({
        url: api.sfSpecialFeeSubject.initDataUrl,
        method: 'post',
        data: {}
      }).then(res => {
        let data = res.data.data
        this.formData.itemCategoryList = data.itemCategoryList
        this.formData.serviceTypeList = data.serviceTypeList
        this.formData.snCompanyBrandList = data.snCompanyBrandList
        this.formData.sfSpecialFeeSubjectConditionDTO = data.sfSpecialFeeSubjectConditionDTO
        this.guaranteeTypeList = [{id: '1', type: '保内'}, {id: '2', type: '保外'}, {id: '3', type: '未知'}]
      })
    },

    // 回显
    getData() {
      if (this.dataId && !isNaN(this.dataId)) {
        this.isEdit = true;
        this.$http({
          url: api.sfSpecialFeeSubject.getDataUrl,
          method: 'post',
          data: {
            id: this.dataId
          },
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          let data = response.data.data || {}
          this.formData = data

          this.setListData(data)

          // this.loadProductOption1()
        })
      } else {
        this.init()
      }
    },

    saveData() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.$baseConfirm('您确定要保存吗？').then(() => {
            console.log(this.selectedGuaranteeTypeIdList)
            if (this.selectedGuaranteeTypeIdList != null && this.selectedGuaranteeTypeIdList.length !== 0) {
              let temp = this.selectedGuaranteeTypeIdList.sort()
              this.formData.sfSpecialFeeSubjectConditionDTO.guaranteeType = temp.join(';')
            } else {
              this.$message.warning('请选择保修类型')
              return
            }

            if (this.selectedBrandIdList != null && this.selectedBrandIdList.length !== 0) {
              let temp = this.selectedBrandIdList.sort()
              this.formData.sfSpecialFeeSubjectConditionDTO.brandId = temp.join(';')
            } else {
              this.$message.warning('请选择品牌')
              return
            }

            if (this.selectedItemCategoryIdList != null && this.selectedItemCategoryIdList.length !== 0) {
              let temp = this.selectedItemCategoryIdList.sort()
              this.formData.sfSpecialFeeSubjectConditionDTO.smallCategoryId = temp.join(';')
            } else {
              this.$message.warning('请选择产品类型')
              return
            }

            if (this.selectedServiceTypeIdList != null && this.selectedServiceTypeIdList.length !== 0) {
              let temp = this.selectedServiceTypeIdList.sort()
              this.formData.sfSpecialFeeSubjectConditionDTO.serverTypeId = temp.join(';')
            } else {
              this.$message.warning('请选择服务类型')
              return
            }

            if (this.itemList != null && this.itemList.length !== 0) {
              let idList = this.itemList.map(item => item.id)
              idList = idList.sort()
              this.formData.sfSpecialFeeSubjectConditionDTO.itemId = idList.join(';')
            } else {
              this.$message.warning('请选择产品')
              return
            }
            this.$mask.open()

            this.$http({
              url: this.isEdit ? api.sfSpecialFeeSubject.updateDataUrl : api.sfSpecialFeeSubject.addDataUrl,
              method: `post`,
              data: this.formData,
              isLoading: true,
            }).then(res => {
              this.$message.success("保存成功！")
              this.$emit('editViewDataUpdate')
              this.$baseReload()
              this.$mask.close()

            }).catch(e => {
              console.error(e)
              this.$message.error("保存失败！")
              this.$mask.close()

            })
          })
        }
      })
    },

    setListData(data) {
      if (data.sfSpecialFeeSubjectConditionDTO.brandId != null) {
        this.selectedBrandIdList = data.sfSpecialFeeSubjectConditionDTO.brandId.split(';')
      }
      if (data.sfSpecialFeeSubjectConditionDTO.smallCategoryId != null) {
        this.selectedItemCategoryIdList = data.sfSpecialFeeSubjectConditionDTO.smallCategoryId.split(';')
      }
      if (data.sfSpecialFeeSubjectConditionDTO.serverTypeId != null) {
        this.selectedServiceTypeIdList = data.sfSpecialFeeSubjectConditionDTO.serverTypeId.split(';')
      }
      if (data.sfSpecialFeeSubjectConditionDTO.guaranteeType != null) {
        let list = data.sfSpecialFeeSubjectConditionDTO.guaranteeType.split(';')
        this.selectedGuaranteeTypeIdList = []
        list.forEach(item => {
          this.selectedGuaranteeTypeIdList.push(Number(item))
        })
        this.guaranteeTypeList = [{id: '1', type: '保内'}, {id: '2', type: '保外'}, {id: '3', type: '未知'}]
      }

      if (data.sfSpecialFeeSubjectConditionDTO.itemId != null && data.sfSpecialFeeSubjectConditionDTO.itemId != '') {
        let list = data.sfSpecialFeeSubjectConditionDTO.itemId.split(';');
        this.$http({
          url: api.basItem.getDataByIdsUrl,
          method: 'post',
          data: {ids: list}
        }).then(res => {
          let list = res.data.data
          if (list != null && list.length !== 0) {
            this.itemList = []
            list.forEach(item => {
              this.itemList.push({id: item.id, name: item.itemName})
            })
          }
        })
      }
    }

  },
};

</script>
<style lang="scss" scoped>
// 输入框的宽度
#containt .table-detail tbody tr td .el-input {
  width: 100% !important;
  width: 165px !important;
}

.current-info {
  margin-left: 5px;
  margin-right: 5px;
}

.item-button {
  margin-right: 0.5vw;
  // margin-top: 5px;
}

/*滚动条整体部分*/
.mytable-scrollbar ::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}
/*滚动条的轨道*/
.mytable-scrollbar ::-webkit-scrollbar-track {
  background-color: #FFFFFF;
}
/*滚动条里面的小方块，能向上向下移动*/
.mytable-scrollbar ::-webkit-scrollbar-thumb {
  background-color: #bfbfbf;
  border-radius: 5px;
  border: 1px solid #F1F1F1;
  box-shadow: inset 0 0 6px rgba(0,0,0,.3);
}
.mytable-scrollbar ::-webkit-scrollbar-thumb:hover {
  background-color: #A8A8A8;
}
.mytable-scrollbar ::-webkit-scrollbar-thumb:active {
  background-color: #787878;
}
/*边角，即两个滚动条的交汇处*/
.mytable-scrollbar ::-webkit-scrollbar-corner {
  background-color: #FFFFFF;
}


::v-deep .vxe-grid .vxe-grid--pager-wrapper {
  display: block;
  width: 100%;
  position: fixed;
  bottom: -38px !important;
  position: absolute !important;
  z-index: 9999999;
  background-color: #ffffff;
}
.btn_zdy {
  // margin: 5px;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}
</style>
